module.exports = "<div class=\"site-sidebar\">\n  <logo></logo>\n  <app-menu-items></app-menu-items>\n  <!--<p>hello</p>-->\n</div>\n<div class=\"sidebar-overlay\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/menus/main-menu/sidebar/menu-item-list.component.html
// module id = ./src/app/home/pages/Dashboard/menus/main-menu/sidebar/menu-item-list.component.html
// module chunks = main